import React, { Component } from 'react';
import PropTypes from 'prop-types';

import 'custom-event-polyfill';

function AddToCart({ disabled, text, addToCart }) {
  return (
    <button
      type='submit'
      className='btn btn--primary-alt btn--add-to-cart btn--block'
      name='addtocart'
      id='AddToCart'
      disabled={disabled}
      onClick={(evt) => addToCart(evt)}
    >
      {text}
    </button>
  );
}

function FindStockistLink({ isShown, text, link }) {
  return (
    <a href={link} className='btn btn--primary-alt'>
      {text}
    </a>
  );
}

export default class ProductFormSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVariantId: 0,
      selectedVariantSKU: '',
      selectedVariant: {},
      selectedOptions: [],
      buttonText: 'Add To Cart',
      disableButton: false,
      defaultOptionsClass: 'product__form-options',
      replacementBtnIsShown: window.theme.replacement_add_to_cart
        ? window.theme.replacement_add_to_cart.showReplacement
        : false,
      replacementBtnText: window.theme.replacement_add_to_cart
        ? window.theme.replacement_add_to_cart.replacementButtonText
        : '',
      replacementBtnLink: window.theme.replacement_add_to_cart
        ? window.theme.replacement_add_to_cart.replacementButtonLink
        : '',
      options: [],
    };

    this.addToCart = this.addToCart.bind(this);
    window.productFormSimple = {
      global: this,
    };
  }

  static getDerivedStateFromProps(props, state) {
    // Set initial values for state based off of props received.
    if (state.selectedVariantId === 0) {
      const buttonText = props.initialVariant.available
        ? window.theme.strings.addToCart
        : window.theme.strings.soldOut;

      return {
        selectedVariantId: props.initialVariant.id,
        selectedVariantSKU: props.initialVariant.sku,
        selectedVariant: props.initialVariant,
        disableButton: !props.initialVariant.available,
        buttonText,
      };
    }
    return null;
  }

  addToCart(evt) {
    if (evt) {
      evt.preventDefault();
    }
    const { selectedVariantId } = this.state;
    window.sideCart.handleAddToCartEvent(evt, selectedVariantId, 1, true);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedVariantId === this.state.selectedVariantId) {
      return;
    }
    const selectedVariant = this.props.variants.find(
      (variant) => variant.id === this.state.selectedVariantId
    );
    // We need to update the product page for variants so let's dispatch an event to handle that
    var variantChanged = new CustomEvent('variant:changed', {
      detail: selectedVariant,
    });
    // Listener for this event found in ../sections/product.js
    document.dispatchEvent(variantChanged);
  }

  componentDidMount() {
    window.productFormSimple.selectedVariantId = this.state.selectedVariantId;
  }

  render() {
    const { initialVariant, variants } = this.props;
    const {
      selectedVariantId,
      disableButton,
      buttonText,
      defaultOptionsClass,
      replacementBtnIsShown,
      replacementBtnText,
      replacementBtnLink,
    } = this.state;
    return (
      <form className='product__form' method='post' action='/cart/add'>
        <input
          type='hidden'
          name='id'
          value={selectedVariantId ? selectedVariantId : initialVariant.id}
        />
        <input type='hidden' name='quantity' value='1' />
        {variants.length > 0 && (
          <div className={defaultOptionsClass}>
            <div className='btn-container'>
              {replacementBtnIsShown ? (
                <FindStockistLink
                  text={replacementBtnText}
                  link={replacementBtnLink}
                />
              ) : (
                <AddToCart
                  disabled={disableButton}
                  text={buttonText}
                  addToCart={this.addToCart}
                />
              )}
            </div>
          </div>
        )}
      </form>
    );
  }
}

AddToCart.propTypes = {
  disabled: PropTypes.bool,
  text: PropTypes.string,
  addToCart: PropTypes.func,
};

FindStockistLink.propTypes = {
  isShown: PropTypes.bool,
  text: PropTypes.string,
  link: PropTypes.string,
};

ProductFormSimple.propTypes = {
  initialVariant: PropTypes.object.isRequired,
  variants: PropTypes.array,
};
